module.exports = __webpack_public_path__ + "media/images/hero-deco-right-320d18f9859768da586a4cf2651816c2.svg";